import styled from "styled-components";

interface ProductBDivImageProps {
  img?: string;
}

export const ProductBDivImage = styled.div<ProductBDivImageProps>`
  background-repeat: no-repeat !important;
  background-position-x: center;
  background-position-y: center;
  background-color: ${(props) => (props.img ? "#fff" : "#18232b")};
  position: relative;
  background-size: cover;
  overflow: hidden;
  border-bottom-left-radius: ${(props) => (props.img ? 0 : "19px")};
  border-bottom-right-radius: ${(props) => (props.img ? 0 : "19px")};
`;

export const ProductBLayer = styled.div`
  background-repeat: no-repeat !important;
  background-position: center;
  background-color: #1d89ec;
  background-size: cover;
  position: absolute;
  top: 0;
  bottom: 15%;
  left: 0;
  right: 0;
  opacity: 0.7;
  background: -webkit-radial-gradient(
    bottom left,
    rgba(78, 71, 49, 0.6),
    #18232b
  );
  background: -moz-radial-gradient(top rigth, #18232b, #16181c);
  background: radial-gradient(to top left, #18232b, #16181c);
`;

export const ProductBLayerDark = styled.div`
  background-repeat: no-repeat !important;
  background-position: center;
  background-color: #18232b;
  background-size: cover;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.4;
  background: #16181c;
  background: linear-gradient(
    0deg,
    rgba(22, 24, 28, 1) 2C4054%,
    rgba(44, 64, 84, 1) 100%
  );
`;

export const ProductBLayerDark2 = styled.div`
  background-repeat: no-repeat !important;
  background-position: center;
  background-color: #18232b;
  background-size: cover;
  position: absolute;
  top: 62%;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 1;
  background: #16181c;
  background: linear-gradient(180deg, rgba(35, 41, 43, 0.2) 0%, #18232b 49.84%);
`;

export const ProductBButton = styled.button`
  background-color: #396ae8;
  color: #ffffff;
  border: none;
  display: block;
  text-align: center;
  font-size: 16px;
  font-family: Manrope;
  padding: 13px 0;
  border-radius: 50px;
  width: 100%;
  @media (min-width: 600px) {
    width: 33.33%;
  }
`;

export const ProductBVideo = styled.video`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 100%;
  object-fit: cover;

  @media only screen and (max-width: 767px) {
    aspect-ratio: 4/5;
  }

  @media only screen and (min-width; 768px) {
    aspect-ratio: 16/5;
  }
`;
export const ProductBVideoFrame = styled.iframe`
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  left: 50%;
  object-fit: cover;
`;
